/* eslint-disable react-refresh/only-export-components -- isReportTableEmpty shared with table components */
import React from 'react';
import { EmptyChart } from '../../components/empty-report';

export const isReportTableEmpty = (
  data: unknown[],
  field: string | string[] = 'y'
) => {
  if (!data?.length) return true;

  if (!field) {
    return !data?.some((d) => d);
  }
  const rows = data as Record<string, unknown>[];
  if (Array.isArray(field)) {
    return !rows?.some((d) => field.some((f) => d[f]));
  }
  return !rows?.some((d) => d[field]);
};

export const EmptyDataWrapper = ({
  children,
  data = [],
  field = null,
  styles = {},
}: {
  children: React.ReactElement;
  data: unknown[];
  field?: string | string[] | null;
  styles?: Record<string, unknown>;
}) => {
  if (isReportTableEmpty(data, field)) {
    return <EmptyChart styles={styles} />;
  }
  return <>{children}</>;
};
